import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import search from "../../assets/search.svg";
import edit from "../../assets/edit.svg";
import productRoute from "../../services/productRoute";
import { useAppContext } from "../../AppContext";
import { useNavigate } from "react-router-dom";
import InstructionModal from "../../components/Modal/InstructionModal";

const ShoppingInstructions = () => {
  const { showToast, productState, setProductState } = useAppContext();
  const navigate = useNavigate();
  const { getShoppingInstructions } = productRoute();
  const [loading, setLoading] = useState(true);
  const [instructions, setInstructions] = useState([]);
  const [searchInstruction, setSearchInstruction] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [showInstructionModal, setShowInstructionModal] = useState(false);
  const [editingInstruction, setEditingInstruction] = useState(null);

  useEffect(() => {
    setProductState("Shopping Instructions");
  }, []);

  const loadInstructions = () => {
    getShoppingInstructions(setLoading, showToast, setInstructions);
  };

  useEffect(() => {
    loadInstructions();
  }, []);

  const handleAddInstruction = () => {
    setEditingInstruction(null);
    setShowInstructionModal(true);
  };

  const handleInstructionClick = (instruction) => {
    navigate(`/admin/shopping-instructions/${instruction?.id || instruction?._id}`);
  };

  const handleEditInstruction = (instruction) => {
    setEditingInstruction(instruction);
    setShowInstructionModal(true);
  };

  const handleStateClick = (pState) => {
    setProductState(pState);
    if (pState === "Products") {
      navigate("/admin/products");
    } else if (pState === "Categories") {
      navigate("/admin/categories");
    } else if (pState === "Shopping Instructions") {
      navigate("/admin/shopping-instructions");
    }
  };

  const filteredInstructions = (instructions || []).filter((instruction) =>
    instruction?.name?.toLowerCase().includes(searchInstruction.toLowerCase())
  );

  return (
    <section className="list-page">
      <div className="d-flex justify-content-between align-items-center header-admin py-5 pe-5 ps-4">
        <h3 style={{ color: "#344054" }}>Shopping Instructions</h3>
        <div className="d-flex gap-3">
          <Button
            className="d-flex align-items-center gap-3 p-2"
            onClick={handleAddInstruction}
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Instruction
          </Button>
        </div>
      </div>
      <div className="d-flex gap-5 mb-3 ps-4" style={{ borderBottom: "1px solid #EDEDED" }}>
        {["Products", "Categories", "Shopping Instructions"].map((pState, index) => (
          <p
            key={index}
            className={`order-item pb-2 mb-0 me-4 ${productState === pState ? "active" : ""}`}
            onClick={() => handleStateClick(pState)}
            style={{ cursor: "pointer", marginBottom: "5px" }}
          >
            {pState}
          </p>
        ))}
      </div>

      <div className="px-3 list-body">
        <div className="d-flex align-items-center justify-content-between py-4">
          <div className="d-flex align-items-center gap-3">
            <p style={{ color: "#1D2939", fontWeight: "500" }} className="my-auto">
              {instructions?.length}{" "}
              {instructions?.length === 1 ? "Instruction" : "Instructions"}
            </p>
            <div
              className="d-flex align-items-center position-relative search-bar py-1 px-1"
              style={{ border: "1px solid #D9D9D9", fontWeight: "500" }}
            >
              {!isFocused && searchInstruction === "" && (
                <img
                  src={search}
                  alt="search"
                  style={{ top: "24%", left: "1.5%" }}
                  className="position-absolute"
                />
              )}
              {searchInstruction !== "" && (
                <i
                  className="bi bi-x"
                  style={{
                    top: "5%",
                    right: "1.5%",
                    position: "absolute",
                    fontSize: "1.5rem",
                    color: "#98A2B3",
                  }}
                  onClick={() => setSearchInstruction("")}
                ></i>
              )}
              <Form.Control
                style={{ border: "none", backgroundColor: "transparent" }}
                placeholder="Search by instruction name"
                className="w-100"
                value={searchInstruction}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => setSearchInstruction(e.target.value)}
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div
            className="justify-content-center align-items-center text-center"
            style={{ padding: "100px" }}
          >
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : filteredInstructions?.length > 0 ? (
          <div className="list-body">
            <div className="list-scroll">
              <Table hover className="my-3">
                <thead>
                  <tr style={{ fontWeight: "600" }} className="mb-2">
                    <th style={{ fontWeight: "600" }} className="pb-3">
                      Name
                    </th>
                    <th style={{ fontWeight: "600" }} className="pb-3">
                      Price
                    </th>
                    <th style={{ fontWeight: "600" }} className="pb-3">
                      Products
                    </th>
                    <th style={{ fontWeight: "600" }} className="pb-3"></th>
                  </tr>
                </thead>
                <tbody className="py-2">
                  {filteredInstructions.map((instruction) => (
                    <tr
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#333333",
                      }}
                      key={instruction?.id}
                      onClick={() => handleInstructionClick(instruction)}
                    >
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                          color: "#194298",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        {instruction?.name}
                      </td>
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        ₦{instruction?.amount?.toLocaleString()}
                      </td>
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        {instruction.totalProducts}
                      </td>
                      <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                        <div className="d-flex align-items-center gap-3">
                          <img
                            src={edit}
                            alt="edit"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditInstruction(instruction);
                            }}
                          />
                          <span
                            style={{
                              cursor: "pointer",
                              textDecoration: "underline",
                              color: "#469B12",
                            }}
                            onClick={() => handleInstructionClick(instruction)}
                          >
                            View
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ) : searchInstruction !== "" ? (
          <div className="fw-medium px-5" style={{ padding: "40px" }}>
            <h4 className="mb-2">No instructions found</h4>
            <Button onClick={() => setSearchInstruction("")}>View all instructions</Button>
          </div>
        ) : (
          <div className="fw-medium" style={{ padding: "40px" }}>
            <h4 className="mb-2">You have no shopping instructions</h4>
            <Button onClick={handleAddInstruction}>Add Instruction</Button>
          </div>
        )}
      </div>
      <InstructionModal
        showInstructionModal={showInstructionModal}
        setShowInstructionModal={setShowInstructionModal}
        instruction={editingInstruction}
        withProducts
        onSaved={loadInstructions}
      />
    </section>
  );
};

export default ShoppingInstructions;
